import React from "react";
import PropTypes from "prop-types";

import { GetPriceRealAndPoints, FormatPoints } from "../../lib/FormatCurrency";
import { Container, Tachado, Box } from "./styles";

export default function PriceDetailProduct({
  price,
  orientation,
  justifyContent,
  displayMode = "both",
}) {
  const { money_de, points_de, money, points } = GetPriceRealAndPoints(price);

  return (
    <Container orientation={orientation} justifyContent={justifyContent} className="mt-4 mb-6">
      {(displayMode === "money" || displayMode === "both") && (
        <Box>
          {money_de && (
            <Tachado className="tachado-price">De: {money_de}</Tachado>
          )}
          <span>
            Por: <p className="por-price">{money}</p>
          </span>
        </Box>
      )}

      {points > 0 && (displayMode === "points" || displayMode === "both") && (
        <Box>
          {points_de > 0 && (
            <Tachado className="tachado-price">
              De: {FormatPoints(points_de)} pts
            </Tachado>
          )}
          <span>
            {displayMode === "both" ? "Ou" : "Por:"}{" "}
            <p className="por-price">{FormatPoints(points)} pts</p>
          </span>
        </Box>
      )}
    </Container>
  );
}

PriceDetailProduct.propTypes = {
  price: PropTypes.object.isRequired,
  orientation: PropTypes.string,
  justifyContent: PropTypes.string,
  displayMode: PropTypes.oneOf(["money", "points", "both"]),
};
